import { render } from "./SkillThumb.vue?vue&type=template&id=6730f330&scoped=true"
import script from "./SkillThumb.vue?vue&type=script&lang=js"
export * from "./SkillThumb.vue?vue&type=script&lang=js"

import "./SkillThumb.vue?vue&type=style&index=0&id=6730f330&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6730f330"]])

export default __exports__